export default __webpack_public_path__ + "static/media/Aura-Egg__60.36a94373.png";